import { callAPI } from './api.js';
import { prepareAndInitSMS } from './helpers.js';

class NojuCheckoutSDK {
  constructor(config = {}) {
    this.config = {
      language: 'en',
      ...config
    };

    // Internal state
    this.webClickId = null;
    this.afToken = null;
    this.verifReqId = null;
    this.sessionId = null;
    this.smsShortCode = null;
    this.smsKeyword = null;

    // Auto-call saveTraffic if configId is provided
    if (this.config.configId) {
      this._saveTraffic();
    }
  }

  async _saveTraffic() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const clickId = urlParams.get('gclid') ||
                      urlParams.get('wbraid') ||
                      urlParams.get('gbraid') ||
                      urlParams.get('click_id');

      const response = await callAPI({
        click_id: clickId,
        config_id: this.config.configId,
        path: window.location.pathname,
        qs: window.location.search
      }, 'saveTraffic');

      if (response.status === 'success' && response.payload) {
        if (response.payload.ref_id) {
          this.webClickId = response.payload.ref_id;
        }
        if (response.payload.anti_fraud_token) {
          this.afToken = response.payload.anti_fraud_token;
        }

        // Inject anti-fraud script if provided
        if (response.payload.antifraud_js) {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.text = response.payload.antifraud_js;
          document.body.appendChild(script);
          document.dispatchEvent(new Event('DCBProtectRun'));
        }
      }
    } catch (error) {
      console.warn('Failed to save traffic:', error);
    }
  }

  async initSubscription({ phoneNumber }) {
    const response = await callAPI({
      phone_number: phoneNumber,
      country_code: this.config.countryCode,
      path: window.location.pathname,
      web_click_id: this.webClickId,
      config_id: this.config.configId,
      qs: window.location.search,
      language: this.config.language,
      af_token: this.afToken
    }, 'initSubscription');

    if (response.status === 'success' && response.payload) {
        this.sessionId = response.payload.session_id;
        this.verifReqId = response.payload.ref_id;
        this.smsShortCode = response.payload.short_code;
        this.smsKeyword = response.payload.keyword;

        if (response.payload.anti_fraud_token){
          this.afToken = response.payload.anti_fraud_token;
        }
        // Inject anti-fraud script if provided
        if (response.payload.antifraud_js) {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.text = response.payload.antifraud_js;
          document.body.appendChild(script);
          document.dispatchEvent(new Event('DCBProtectRun'));
        }
    }

    return response;
  }

  async verifyOTP({ code }) {
    if (!this.verifReqId) {
      throw new Error('NojuCheckoutSDK: No verifReqId available. Call initSubscription first.');
    }

    const response = await callAPI({
      verif_req_id: this.verifReqId,
      code,
      path: window.location.pathname,
      web_click_id: this.webClickId,
      config_id: this.config.configId,
      language: this.config.language
    }, 'verifyOTP');

    return response;
  }

  async listenSubscription(options = {}) {
    if (!this.sessionId) {
      throw new Error('NojuCheckoutSDK: No sessionId available. Call initSubscription first.');
    }

    const response = await callAPI({
      session_id: this.sessionId,
      path: window.location.pathname,
      web_click_id: this.webClickId,
      config_id: this.config.configId,
      language: this.config.language
    }, 'listenSubscription');

    return response;


  }

  openSmsComposer() {
    if (!this.smsShortCode || !this.smsKeyword) {
      throw new Error('NojuCheckoutSDK: No SMS data available. Call initSubscription first.');
    }
    prepareAndInitSMS(this.smsShortCode, this.smsKeyword);
  }
}

export default NojuCheckoutSDK;
